<div class="chart" [formGroup]="form">
  <app-generic-chart-card
    [title]="'DASHBOARD.CHARTS.APP_CONSUMPTION' | translate"
    [contentTemplate]="appConsumptionContent"
    [headerTemplate]="appConsumptionHeader"
    [caller]="caller"
    [showReloadButton]="true"
  >
    <ng-template #appConsumptionHeader let-data>
      <app-chart-card-header-data [headerData]="headerData"></app-chart-card-header-data>
    </ng-template>
    <ng-template #appConsumptionContent let-data>
      <app-pie-chart
        [data]="data"
        [showLegend]="data ?? false"
        [legendPosition]="'bottom'"
        [labels]="['DASHBOARD.CHARTS.CONSUMED' | translate, 'DASHBOARD.CHARTS.REMAINING' | translate]"
      ></app-pie-chart>
    </ng-template>
  </app-generic-chart-card>
</div>
